var MuiSnackbar = {
    /* your custom class style overrides here */
    anchorOriginTopCenter: {
        top: 28,
    },
};
export default MuiSnackbar;
//# sourceMappingURL=MuiSnackbar.js.map